import { z } from "zod";
import { patientIdSchema } from "./patient";

export const treatmentStateSchema = z.enum([
  "onboarding",
  "active",
  "between_cycles",
  "paused",
  "ended",
]);
export type TreatmentState = z.infer<typeof treatmentStateSchema>;

export const treatmentSchema = z.object({
  id: z.string().uuid(),
  patientId: patientIdSchema,
  state: treatmentStateSchema,
  baselineWeightKg: z.number().positive().nullable(),
  baselineCapturedAt: z.date().nullable(),
  startedAt: z.date(),
  endedAt: z.date().nullable(),
});
export type Treatment = z.infer<typeof treatmentSchema>;
